// removed by extract-text-webpack-plugin
module.exports = {"flex":"_3KhFh8s7XM6kvGGNWhzyhg","white":"_3fqO-JkVQi0KOPaOZTNfaM","username":"_36IyKg1JLgCztPfCriJJpb","content":"_7oZRhXTDR9NtuYmph8-Py","bottomNavigation":"_2qiTMclw-ALTre7RzpQG_l","jss1":"_2WPDTVhUqRQrvaOgnkJl3b","bottomNavigationAction":"_3E7nwmXkVDUkcAE3dGFkWp","alert":"CLIRyWxwc_0VhT9KWuc2X","linkStyle":"_21C1grkv3O0cFp9oBDCPdD","closebtn":"_3tEbGOPR95V5-Ns_F-x6zH","headerDescription":"_5OcPLYKzNDVLMTQs-0Cxa"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/admin/Admin.scss
// module id = 1634
// module chunks = 0